import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { EnvironmentService } from '../../../core/environment/environment.service';
import { LanguageService } from '../../../core/language/language.service';
import { SdkAnalyticsService } from '@app/shared/services/sdk-analytics/sdk-analytics.service';
import { PermissionService } from '../../../core/permissions/permission.service';
import { normalizePath, sanitizeLabel } from '../../utils';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@angular/router";
import * as i3 from "../../../core/environment/environment.service";
import * as i4 from "../../../core/language/language.service";
import * as i5 from "../../services/sdk-analytics/sdk-analytics.service";
import * as i6 from "../../../core/permissions/permission.service";
var serviceUrl = '/menu';
var searchResultsUrl = '/busca';
var MenuService = /** @class */ (function () {
    function MenuService(http, router, environmentService, languageService, _sdkAnalyticsService, permissionService) {
        this.http = http;
        this.router = router;
        this.environmentService = environmentService;
        this.languageService = languageService;
        this._sdkAnalyticsService = _sdkAnalyticsService;
        this.permissionService = permissionService;
        this.menuSubject = new BehaviorSubject(this.menuList);
        this.apiUrl = this.environmentService.envModel.appSettings.apiUrlMenu;
    }
    MenuService.prototype.getMenu = function () {
        return this.menuSubject.asObservable();
    };
    /**
     * Busca menu do endpoint EN4 e inicializa cache de permissoes
     * O cache e criado na primeira chamada bem-sucedida ao endpoint /menu
     */
    MenuService.prototype.fetchMenu = function (language, jwt) {
        var _this = this;
        var headers = new HttpHeaders({ jwt: jwt });
        this.http.get(this.getServiceUrl(language, jwt), { headers: headers, withCredentials: true })
            .subscribe(function (res) {
            _this.updateMenuList(res);
            // Salva permissoes no cache apos primeira chamada bem-sucedida ao endpoint /menu
            _this.savePermissionsToCache(res);
        });
    };
    /**
     * Salva permissoes no cache usando PermissionService
     * Estrutura: { menus, timestamp, userid }
     */
    MenuService.prototype.savePermissionsToCache = function (menus) {
        var now = Date.now();
        var permissionTree = {
            menus: menus,
            timestamp: now,
            expiresAt: now + 30 * 60 * 1000,
            userId: '' // Sera preenchido pelo PermissionService com sanitizeOperatorId
        };
        this.permissionService.savePermissionsToStorage(permissionTree);
    };
    MenuService.prototype.fullMenu = function (language, menuName, menuCategory, date) {
        if (menuName && this.router && this.router.url) {
            this._sdkAnalyticsService.trackEvent('click', {
                custom_path: normalizePath(this.router.url),
                implementation_team: "output-de-dados-do-ativo-monitores-de-status:experiencia-do-cliente",
                detail: menuCategory ? "menu-" + sanitizeLabel(menuName) + ":" + sanitizeLabel(menuCategory) : "menu-" + sanitizeLabel(menuName)
            });
        }
        window.scrollTo(0, 0);
        if (menuCategory)
            this.router.navigate([serviceUrl, { 'menuName': menuName, 'category': menuCategory, 'r': date }]);
        else
            this.router.navigate([serviceUrl, { 'menuName': menuName }]);
        this.scrollIntoCategory(menuCategory);
    };
    MenuService.prototype.openContext = function (route) {
        this.setTimeoutNavigation(route, 3);
    };
    MenuService.prototype.setTimeoutNavigation = function (route, retries) {
        var _this = this;
        var attempts = 0;
        var intervalId = setInterval(function () {
            _this.router.navigate([route]).then(function (success) {
                if (success) {
                    clearInterval(intervalId);
                }
                else {
                    attempts++;
                    if (attempts >= retries) {
                        clearInterval(intervalId);
                    }
                }
            }).catch(function (error) {
                attempts++;
                if (attempts >= retries) {
                    console.log(error);
                    clearInterval(intervalId);
                }
            });
        }, 500);
    };
    MenuService.prototype.getPath = function () {
        var _this = this;
        this.menuList.forEach(function (menu) {
            if (menu.categories != null) {
                menu.categories.forEach(function (subCategory) {
                    if (subCategory.subMenus != null) {
                        subCategory.subMenus.forEach(function (sub) {
                            sub.path = _this.languageService.translate(menu.translationKey) + " > " + _this.languageService.translate(subCategory.translationKey) + (sub.subCategory == null ? " > " : " > " + _this.languageService.translate(sub.subCategory) + " > ") + _this.languageService.translate(sub.translationKey);
                        });
                    }
                });
            }
        });
    };
    MenuService.prototype.searchFor = function (searchTerm) {
        window.scrollTo(0, 0);
        var url = this.router.url;
        this.router.navigate([searchResultsUrl, { 'searchTerm': searchTerm }]);
    };
    MenuService.prototype.filterMenu = function (value) {
        if (!value) {
            return null;
        }
        var filterValue = value.toLowerCase();
        var result = new Array();
        var resultSubMenu;
        resultSubMenu = this.filterSubMenus(filterValue, "name");
        resultSubMenu = resultSubMenu.concat(this.filterSubMenus(filterValue, "path"));
        resultSubMenu = resultSubMenu.filter(function (elem, index, self) { return index === self.indexOf(elem); }); //Removes duplicates entries
        resultSubMenu.slice().sort(function (a, b) { return a.name.localeCompare(b.name); }).forEach(function (x) {
            result.push(x);
        });
        return result;
    };
    MenuService.prototype.filterSubMenus = function (filterValue, filterField) {
        var menus = this.menuList;
        var result = new Array();
        for (var i = 0; i < menus.length; i++) {
            var menu = menus[i];
            if (menu.categories != null) {
                for (var x = 0; x < menu.categories.length; x++) {
                    var category = menu.categories[x];
                    if (category.subMenus != null) {
                        for (var z = 0; z < category.subMenus.length; z++) {
                            var subMenu = category.subMenus[z];
                            var field = (filterField == "name") ? this.languageService.translate(subMenu.translationKey) : subMenu.path;
                            if (field.toLowerCase().includes(filterValue)) {
                                result.push(subMenu);
                            }
                        }
                    }
                }
            }
        }
        return result;
    };
    MenuService.prototype.updateMenuList = function (newMenu) {
        this.menuList = newMenu;
        this.getPath();
        this.menuSubject.next(this.menuList);
        return this.menuList;
    };
    MenuService.prototype.getServiceUrl = function (language, jwt) {
        return this.apiUrl + serviceUrl;
    };
    MenuService.prototype.scrollIntoCategory = function (category) {
        var element;
        var header = 0;
        if (document.getElementById("header") != null && document.getElementById("header").offsetHeight != null)
            header = document.getElementById("header").offsetHeight;
        if (document.getElementById('title_' + category) != null)
            element = document.getElementById('title_' + category);
        if (element) {
            var scrollElm_1 = document.scrollingElement;
            scrollElm_1.scrollTop = 0;
            setTimeout(function () { scrollElm_1.scrollTop = element.offsetTop - header; }, 100);
        }
    };
    MenuService.ngInjectableDef = i0.defineInjectable({ factory: function MenuService_Factory() { return new MenuService(i0.inject(i1.HttpClient), i0.inject(i2.Router), i0.inject(i3.EnvironmentService), i0.inject(i4.LanguageService), i0.inject(i5.SdkAnalyticsService), i0.inject(i6.PermissionService)); }, token: MenuService, providedIn: "root" });
    return MenuService;
}());
export { MenuService };
